import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

export type SchemaStand = {
  gesamt: number;
  angewandt: number;
  ausstehend: number;
};

/**
 * Der Migrationsstand fuer die Einstellungsseite (A31.2).
 *
 * useQuery, nicht useMutation: Das ist eine Auskunft ueber den Zustand,
 * kein Vorgang. Und sie laeuft NUR auf dieser Seite — der Waechter im
 * Fehlerpfad (api/lib/schema.php) braucht sie nicht, er sieht selbst
 * nach, wenn etwas schiefgeht.
 *
 * `retry: false`: Antwortet der Server hier nicht, ist die Auskunft
 * gerade nicht zu haben. Dreimal nachzufragen macht sie nicht wahrer und
 * verzoegert nur die Zeile darunter.
 */
export function useSchemaStand() {
  return useQuery({
    queryKey: ['schema-stand'],
    queryFn: () => apiFetch<{ schema: SchemaStand }>('/schema.php'),
    retry: false,
    staleTime: 5 * 60_000
  });
}
